export const getUserPercentForABTest = async (userId: string | number): Promise<number> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(userId.toString());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = new Uint8Array(hashBuffer.slice(0, 4));
    const hashInt = hashArray.reduce((acc, byte, i) => acc + byte * 256 ** (3 - i), 0);

    return hashInt % 100;
};
